module.exports = __webpack_public_path__ + "static/media/Light grey 12-1.54f7ce3b.jpg";